import React from 'react';
import {
    Link
} from 'react-router-dom'
import './Entry.css';
import EntryConfig from './entryconfigType';


function Entry({conf}:{conf:EntryConfig}) {
  return (
    <div className='menu-item' key={conf.link.toString()}>
        <Link to={conf.link}>
          <img src={conf.img} alt={conf.img_alt} className='img'/>
          <p>
            {conf.text}
          </p>
        </Link>
    </div>
  );
}

export default Entry;